export default `<svg width="100%"
    height="100%" viewBox="0 0 26 24"
    stroke="none" fill="currentColor" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <path
        d="M10,1.353L10,20.647C10,21.394 9.394,22 8.647,22L1.353,22C0.606,22 0,21.394 0,20.647L0,1.353C0,0.606 0.606,0 1.353,0L8.647,0C9.394,0 10,0.606 10,1.353Z" />
    <path
        d="M24,1.353L24,20.647C24,21.394 23.394,22 22.647,22L15.353,22C14.606,22 14,21.394 14,20.647L14,1.353C14,0.606 14.606,0 15.353,0L22.647,0C23.394,0 24,0.606 24,1.353Z" />
</svg>`;